"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteFiles = void 0;
var useFormDataAPICallAsync_1 = require("./useFormDataAPICallAsync");
exports.useDeleteFiles = function (_a) {
    var application = _a.application, category = _a.category, bearer = _a.bearer;
    var _b = useFormDataAPICallAsync_1.useDeleteFileAPICallAsync({
        bearer: bearer,
        api: {
            method: 'DELETE',
            endpoint: application + "/" + category,
        },
        customFields: {},
    }), result = _b.result, call = _b.call;
    return {
        result: result,
        call: call,
    };
};
//# sourceMappingURL=useDeleteFiles.js.map